import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/discover/ResponsiveDiscoverWrapper.tsx");
